<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col head">
                            <h3 class="mb-0">
                              Faturas
                            </h3>

                            <!--<base-button size="sm" class="clickable" @click="goCsv()">Exportar</base-button>-->
                          </div>
                        </div>
                      </div>

                      <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>


                      <!-- Card stats -->
                      <div class="row" v-if="!loading" style="padding: 20px 20px 40px 20px;">
                         <div class="col-xl-3">
                              <stats-card title="Totais"
                                          type="gradient-primary"
                                           v-bind:sub-title="facets.faturasPagas || '0'"
                                          icon="fas fa-check"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">faturas pagas.</span>
                                  </template>
                              </stats-card>
                          </div>
                          <div class="col-xl-3">
                              <stats-card title="Laboratórios"
                                          type="gradient-primary"
                                           v-bind:sub-title="facets.faturasLab || '0'"
                                          icon="fas fa-flask"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">faturas pagas.</span>
                                  </template>
                              </stats-card>
                          </div>
                          <div class="col-xl-3">
                              <stats-card title="Dentistas"
                                          type="gradient-primary"
                                          v-bind:sub-title="facets.faturasDen || '0'"
                                          icon="fas fa-user-md"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">faturas pagas.</span>
                                  </template>
                              </stats-card>
                          </div>

                          <div class="col-xl-3">
                              <stats-card title="Suspensas"
                                          type="gradient-primary"
                                          v-bind:sub-title="facets.faturasExtras || '0'"
                                          icon="fas fa-exclamation"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">faturas suspensas.</span>
                                  </template>
                              </stats-card>
                          </div>
                      </div>
                      
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                          <base-input class="mr-2 flex-grow-1" type="text" placeholder="buscar por descritivo" v-model="filtros.nome"></base-input>
                          >
                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="faturasList">
                            <template slot="columns">
                              <th>Nome Completo / Razão Social</th>
                              <th>E-mail</th>
                              <th>Descritivo</th>
                              <th>Valor</th>
                              <th>Data do Pagamento</th>
                              <th>Data de Criação</th>
                              <th class="text-center">Ações</th>
                             
                            </template>

                            <template slot-scope="{row}" v-if="!loading">
                              <td>
                                {{ row.titular_nome || '-' }}
                              </td>
                                <td>
                                {{ row.titular_email }}
                              </td>
                                <td>
                                  {{ row.descritivo }}
                              </td>
                               <td>
                                R$ {{ (row.valor_pagamento / 100).toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                                <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.data_pagamento)}}</span>
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>

                              <td class="text-center actions">
                                <a @click="goExternal(row.fatura_pdf)" title="Fatura em PDF">
                                  <i class="fas fa-file-pdf"></i>
                                </a>

                                <a  @click="goExternal(row.fatura_url)" title="Fatura via link">
                                  <i class="fas fa-file-alt"></i>
                                </a>
                              </td>
                           

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import faturas from '@/cflow/faturas.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../components/BaseButton.vue';
  import BaseInput from '../components/BaseInput.vue';
  import storage from 'storage';
  import config from 'config';
  export default {
    name: 'tables',
    components: {
      BaseButton,
      BaseInput
    },
    methods: {
      goCsv: function() {

          const api = config[process.env.NODE_ENV].api.endpoint;
          const csv = `${api}/csv/usuarios`;
          window.location = csv;

      },
        setTipo: function(tipo, flag) {
        let tiposList;
        if(flag == 'color') tiposList = { 'refunded' : 'default', 'plano_dentista' : 'info'};
        if(flag == 'label') tiposList = { 'refunded' : 'Reembolso', 'plano_dentista' : 'Dentista'};
       for (let key in tiposList) {
            if(tipo == key) {
                return tiposList[key];
            }
        }
      },
      setStatus: function(status, flag) {
        let statusList;
        if(flag == 'color') statusList = { 'pending' : 'warning', 'paid' : 'success', 'authorized' : 'info', 'refunded': 'info', 'expired' : 'secondary', 'canceled': 'danger'};
        if(flag == 'label') statusList = { 'pending' : 'Pendente', 'paid' : 'Pago', 'authorized' : 'Autorizado', 'refunded': 'Reembolsado', 'expired' : 'Expirado', 'canceled': 'Cancelado'};
       for (let key in statusList) {
            if(status == key) {
                return statusList[key];
            }
        }
        if(flag == 'color') return 'secondary';
        if(flag == 'label') return 'Outros';
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;
          faturas.listar({filtros: this.filtros}, 0).then(res => {
            this.faturasList = res.pagamentos;
            this.facets = res.info;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(erro => {
            console.err('ERROR', erro);
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped += this.faturasList.length;
        this.initLoad(this.skiped);
      },
      goExternal(url){
        window.open(url, '_blank');
      },
      filterStatus: function(facets) {
        const terms = facets.status.terms;
        let status = {};
        for (let key in terms) {
           status[terms[key].term] =  terms[key].count;
        }
        return status;
      },
      initLoad: function() {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([faturas.listar([], this.skiped)]).then( res => {
          this.faturasList = this.faturasList.concat(res[0].pagamentos);
          this.facets = res[0].info;
          this.loading = false;
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        skiped: 0,
        facets: {},
        usuariosList:[],
        faturasList:[],
        idxList:[],
        status: [{'nome': 'Pendente', 'valor': 'pending'}, {'nome': 'Pago', 'valor': 'paid'}, {'nome': 'Cancelado', 'valor': 'canceled'}, {'nome': 'Pago Parcialmente', 'valor': 'partially_paid'}, {'nome': 'Reembolsado', 'valor': 'refunded'}, {'nome': 'Expirado', 'valor': 'expired'}, {'nome': 'Autorizado', 'valor': 'authorized'}],
        coresStatus: ['warning','info','primary','info','info','success','danger','danger'],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            none: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.head {
  display: flex;
  justify-content: space-between;
}
.actions a {
  font-size: 16px;
  margin: 0 5px;
  cursor: pointer;
}
</style>
